// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Z8J80","image":"Header_image__OQg0g","name":"Header_name__Nx_Q-","info":"Header_info__1Ff5T","infoRow":"Header_infoRow__GNr3a"};